import React from "react";
import GameContainer from "../../../../../edu_lms/components/Game";
import PreviewContainer from "../../../../../edu_lms/components/Game/Preview";

const REV_001 = ({ activity, bookId }) => {
	return (
		<GameContainer data={activity}>
			<PreviewContainer data={activity} />
		</GameContainer>
	);
};

export default REV_001;
